<template>
  <div>
    <FiltersDesktopVersion
      :category-options="categoriesOption"
      class="hidden md:block"
      :competition-options
      :currency-filter-options
      :grade-options
      :initial-values
      @submit="handleSubmit"
    />

    <FiltersMobileVersion
      :category-options="categoriesOption"
      class="md:hidden"
      :competition-options
      :currency-filter-options
      :grade-options
      :initial-values
      @submit="handleSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import { mergeObject } from '@/utils/mergeObject'

import type { FilterValues } from './Filters.types'
import { getInitialValues } from './Filters.utils'
import FiltersDesktopVersion from './components/FiltersDesktopVersion.vue'
import FiltersMobileVersion from './components/FiltersMobileVersion.vue'
import { useOptions } from './composables/useOptions'
import { sanitizeQueryParams } from './utils/sanitizeQueryParams'

const emit = defineEmits(['submit'])
const route = useRoute()

const {
  categoriesOption,
  gradeOptions,
  currencyFilterOptions,
  competitionOptions,
} = useOptions()

const defaultInitialValues = getInitialValues()

const initialValues = computed(() =>
  mergeObject(defaultInitialValues, route.query as Record<string, string>),
)

const { trackClick } = useTracking()

function handleSubmit(values: FilterValues) {
  const sanitizedFilters = sanitizeQueryParams(values)

  trackClick({
    name: Object.keys(sanitizedFilters).join(' '),
    page_type: 'opportunities_inventory',
    value: Object.values(sanitizedFilters).join(' '),
    zone: 'header_filters',
    role: 'merchant',
  })

  emit('submit', sanitizedFilters)
}
</script>
